/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Position_LabelInputs */

const vi_warehouse_quick_position_label = /** @type {(inputs: Warehouse_Quick_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí lưu kho cho phiên quét`)
};

/**

* @param {Warehouse_Quick_Position_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_position_label = /** @type {((inputs?: Warehouse_Quick_Position_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Position_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_position_label(inputs)
});